var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMysql = function SvgMysql(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B9BDB",
    d: "M9.57 28.766v6.972c.059 3.66 6.082 6.621 15.43 6.621s15.367-2.96 15.43-6.62v-6.973z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40.43 28.738c0 3.883-6.047 7.032-15.43 7.032S9.57 32.62 9.57 28.738s6.047-7.031 15.43-7.031 15.43 3.145 15.43 7.031"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B9BDB",
    d: "M9.57 21.734v6.192c.059 3.66 6.082 7.012 15.43 7.012s15.367-3.352 15.43-7.012v-6.192z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40.43 21.707c0 3.883-6.047 7.031-15.43 7.031S9.57 25.59 9.57 21.707s6.047-7.031 15.43-7.031 15.43 3.144 15.43 7.031"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B9BDB",
    d: "M9.57 14.703v6.192c.059 3.66 6.082 7.011 15.43 7.011s15.367-3.351 15.43-7.011v-6.192z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#3ED6FF",
    d: "M40.43 14.676c0 3.883-6.047 7.031-15.43 7.031S9.57 18.559 9.57 14.676 15.617 7.645 25 7.645s15.43 3.144 15.43 7.03"
  })));
};
export default SvgMysql;